import { render, staticRenderFns } from "./QrCodeReader.vue?vue&type=template&id=6f803600&"
import script from "./QrCodeReader.vue?vue&type=script&lang=ts&"
export * from "./QrCodeReader.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports